var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationAuthorisation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 29c3.028 0 4 1.094 4 4.5 0 2.666-1.402 5.5-4 5.5s-4-2.834-4-5.5c0-3.406.972-4.5 4-4.5zm0 12c3.42 0 6-3.225 6-7.5 0-3.026-.682-6.5-6-6.5s-6 3.474-6 6.5c0 4.275 2.58 7.5 6 7.5z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M53.515 42.857l5-3-1.03-1.714-5 3 1.03 1.714M63 49h6c1.626 0 3-1.832 3-4v-2.58l-7.504-4.288-.992 1.736L70 43.58V45c0 1.224-.703 2-1 2h-6v2",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 66h2v-9c0-8.01-4.446-9.7-9.152-11.488-1.743-.662-3.544-1.347-5.352-2.38l-.992 1.736c1.943 1.111 3.904 1.856 5.633 2.513C57.872 49.181 61 50.369 61 57v9M17 66h2v-9c0-6.631 3.128-7.819 7.863-9.619 1.729-.657 3.69-1.402 5.633-2.513l-.992-1.736c-1.808 1.033-3.609 1.718-5.352 2.38C21.446 47.3 17 48.99 17 57v9",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 44.882l-3.803 1.901-2.91-2.91 1.187-1.78 5.526.921 5.526-.921 1.187 1.78-2.91 2.91L40 44.882zm-4.197 4.335L40 47.118l4.197 2.099 5.09-5.09-2.813-4.22L40 40.986l-6.474-1.079-2.813 4.22 5.09 5.09z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M36 41h-2v-4h2zM46 41h-2v-4h2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M41 56h-2v-2h2zM41 52h-2v-2h2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 39c.132 0 3.261-.013 5.447-1.105l.108-.063c.137-.092 3.384-2.333 4.435-9.69L50 28v-4h-2v3.929c-.861 5.917-3.201 7.96-3.519 8.212-1.762.844-4.455.859-4.482.859-.025 0-2.717-.015-4.478-.858-.313-.25-2.661-2.305-3.521-8.213V24h-2l.01 4.142c1.051 7.357 4.298 9.598 4.435 9.69l.108.063C36.739 38.987 39.868 39 40 39M30 24h2c0-5.532 2.467-8 8-8 5.533 0 8 2.468 8 8h2c0-6.636-3.364-10-10-10s-10 3.364-10 10",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M34.955 27.096l10-4 3.598 1.799.894-1.79-4.402-2.201-10 4-3.598-1.799-.894 1.79 4.402 2.201M55 66h-2v-8h2zM27 66h-2v-8h2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M25 43.5l2-.5V27H8v2h17",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M10 59H8V27h19v2H10v30",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M22 35h-2v-2h2zM18 35h-2v-2h2zM14 35h-2v-2h2zM22 39h-2v-2h2zM18 39h-2v-2h2zM14 39h-2v-2h2zM22 43h-2v-2h2zM18 43h-2v-2h2zM14 43h-2v-2h2zM18 47h-2v-2h2zM14 47h-2v-2h2zM14 51h-2v-2h2zM14 55h-2v-2h2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationAuthorisation;